"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTypeEnum = void 0;
var FileTypeEnum;
(function (FileTypeEnum) {
    FileTypeEnum["CSV"] = "CSV";
    FileTypeEnum["XLSX"] = "XLSX";
})(FileTypeEnum = exports.FileTypeEnum || (exports.FileTypeEnum = {}));
//# sourceMappingURL=file-type-enum.js.map